import { Anchor } from '@repo/ui/src/components/Anchor';
import { MobileFavoriteLink } from './styles';

const MobileFavoriteLinks = ({ links }) => {
  if (!links) return null;

  return (
    <>
      {links.map(({ link }, i) => (
        <MobileFavoriteLink {...link} key={i}>
          <Anchor
            className="tw-px-6 tw-py-2 tw-flex tw-justify-start tra-text-web-heading-5 tw-leading-10"
            {...link}
          >
            {link.displayName}
          </Anchor>
        </MobileFavoriteLink>
      ))}
      <hr aria-hidden className="tw-mb-0" />
    </>
  );
};

export default MobileFavoriteLinks;
